import React from "react";
import Boxes from "./Boxes";
import "./Skills.css";
import { AiFillHtml5 } from "react-icons/ai";
import { DiCss3 } from "react-icons/di";
import { IoLogoJavascript } from "react-icons/io";
import { BsFillBootstrapFill } from "react-icons/bs";
import { SiReact } from "react-icons/si";
import { SiFirebase } from "react-icons/si";

export const Skills = () => {
  return (
    <div className="container">
      <div className="skills-header">
        <div className="skills-content">
          <h1>My Skills</h1>
          <div className="border-about"> </div>
          <div className="border-design">
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-sm-12"
                data-aos="fade-right"
              >
                <Boxes
                  heading="HTML5"
                  text="HTML5 is a markup language used for structuring and presenting content on the World Wide Web."
                  icon={<AiFillHtml5 />}
                />
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-12"
                data-aos="zoom-in-up"
              >
                <Boxes
                  heading="CSS3"
                  text="Cascading Style Sheets is a style sheet language used for describing the presentation of a document."
                  icon={<DiCss3 />}
                />
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-12 "
                data-aos="fade-left"
              >
                <Boxes
                  heading="javaScript"
                  text="JavaScript is the world's most popular programming language. JavaScript is the programming language of the Web."
                  icon={<IoLogoJavascript />}
                />
              </div>
            </div>
            <br />
            <div className="row">
              <div
                className="col-lg-4 col-md-6 col-sm-12"
                data-aos="fade-right"
              >
                <Boxes
                  heading="Boostrap"
                  text="Bootstrap is a free and open-source CSS framework directed at responsive, mobile-first front-end web development."
                  icon={<BsFillBootstrapFill />}
                />
              </div>
              <div
                className="col-lg-4 col-md-6 col-sm-12"
                data-aos="zoom-in-up"
              >
                <Boxes
                  heading="React.js"
                  text="React is an open-source front-end JavaScript library for building user interfaces or UI components. It is maintained by Facebook. "
                  icon={<SiReact />}
                />
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12" data-aos="fade-left">
                <Boxes
                  heading="Firebase"
                  text="Firebase is a platform developed by Google for creating mobile and web applications. "
                  icon={<SiFirebase />}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Skills;
